import { render, staticRenderFns } from "./CRMTeam.vue?vue&type=template&id=cadf7dc8&scoped=true&"
import script from "./CRMTeam.vue?vue&type=script&lang=js&"
export * from "./CRMTeam.vue?vue&type=script&lang=js&"
import style0 from "./CRMTeam.vue?vue&type=style&index=0&id=cadf7dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadf7dc8",
  null
  
)

export default component.exports